import React, { useState, useEffect, useRef } from "react"
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useParams } from "react-router-dom";
import BotaoVoltar from "./common/botaoVoltar";
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import { URL_API } from '../config/urls'
import fetchWithToken from 'config/UseFetchWithToken';

export default function EditarAf() {

	const [dados, setDados] = useState({});
	const [dadosSrf, setDadosSrf] = useState([]);
	const [mostraMensagem, setMostrarMensagem] = useState(false)
	const [mensagem, setMensagem] = useState("")
	const txtCodigo = useRef(null);
	const txtNome = useRef(null);
	const txtResponsavel = useRef(null);
	const txtEmail = useRef(null);
	const txtSrf = useRef(null);
	let { id } = useParams();

	useEffect(() => {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

		fetchWithToken(`${URL_API}/api/v1/srf/obterSrf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					this.resultado = "Erro na leitura dos dados de SRF"
				}
				else {
					setDadosSrf(res)
					if (id > 0) {
						fetchWithToken(`${URL_API}/api/v1/af/${id}`, requestAuthorization)
							.then(res2 => res2.json())
							.then(res2 => {
								if (res2 === "") {
									this.resultado = "Erro na leitura dos dados de AF"
								}
								else {
									setDados(res2[0])
								}
							})
							.catch(_err => {
								alert("Erro interno na aplicação - " + _err)
								console.error("Erro interno na aplicação - " + _err)
							});
					}
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
	}, [id])

	function controlarItem(e) {
		setDados(_dados => ({ ...dados, [e.target.name]: e.target.value }))
		return null
	}

	function controlarSrf(e) {
		setDados(_dados => ({ ...dados, srfCodigo: e.target.value }))
		return null
	}

	function fecharMensagem() {
		setMostrarMensagem(false)
		return null
	}

	function salvar(_e) {
		let metodo = 'POST'
		let url = `${URL_API}/api/v1/af/`
		if (id > 0) {
			url = url + dados.codigo
			metodo = 'PUT'
		}
		else{
			url = url + "inserirAf"
		}

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const opcoes = {
			method: metodo,
			headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${token_keycloack}` },
			body: JSON.stringify(dados)
		};
		if (!dados.codigo.trim().length) {
			alert("O campo código é obrigatório!")
			txtCodigo.current.focus()
			return false
		}
		if (!dados.nome.trim().length) {
			alert("O campo nome é obrigatório!")
			txtNome.current.focus()
			return false
		}
		if (!dados.responsavel.trim().length) {
			alert("O campo responsável é obrigatório!")
			txtResponsavel.current.focus()
			return false
		}
		if (!dados.email.trim().length) {
			alert("O campo email é obrigatório!")
			txtEmail.current.focus()
			return false
		}
		if (!dados.email.match(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/)) {
			alert("Email inválido!")
			txtEmail.current.focus()
			return false
		}
		if (dados.srfCodigo == null || !dados.srfCodigo.trim().length) {
			alert("Selecione uma SRF relacionada a AF!")
			txtSrf.current.focus()
			return false
		}
		fetch(url, opcoes)
			.then(res => res.text())
			.then(_res => {
				const retorno = JSON.parse(_res);
				if(retorno.status === 500){
					setMensagem("Erro interno na aplicação - "+retorno.trace);
				}else{
					if (id === "0") {
						setMensagem("O registro foi incluído!")
					}
					else {
						setMensagem("O registro foi alterado!")
					}
				}
				setMostrarMensagem(true)
				window.scrollTo(0, 0)
			})
			.catch(_err => {
				alert("Erro interno na aplicação.")
				console.error("Erro interno na aplicação - " + _err)
			});
		return null
	}

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					<Collapse in={mostraMensagem}>
						<Alert action={<IconButton aria-label="close" color="inherit" size="small" onClick={ () => fecharMensagem() } focusRipple={mostraMensagem} ><CloseIcon fontSize="inherit" /></IconButton>} sx={{ mb: 2 }}>{mensagem}</Alert>
					</Collapse>
					<header className="main">
						<h2>DISTVAF - Cadastro de AF</h2>
					</header>
				</div>
			</div>
			<div className="row">
				<div className="col-6">
				</div>
				<div className="col-6">
					<BotaoVoltar />
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<form>
						<label className="margem-antes">Código</label>
						<input type="text" value={dados.codigo || ''} name="codigo" onChange={controlarItem} maxLength="3" ref={txtCodigo}/>
						<label className="margem-antes">Nome</label>
						<input type="text" value={dados.nome || ''} name="nome" onChange={controlarItem} maxLength="40"ref={txtNome} />
						<label className="margem-antes">Responsavel</label>
						<input type="text" value={dados.responsavel || ''} name="responsavel" onChange={controlarItem} maxLength="40" ref={txtResponsavel}/>
						<label className="margem-antes">Email</label>
						<input type="text" value={dados.email || ''} name="email" onChange={controlarItem} maxLength="45" ref={txtEmail} />
						<label className="margem-antes">Telefone</label>
						<input type="text" value={dados.telefone || ''} name="telefone" onChange={controlarItem} maxLength="20" />
						<label className="margem-antes">Usuário</label>
						<input type="text" value={dados.usuario || ''} name="usuario" onChange={controlarItem} maxLength="30" />
						<label className="margem-antes">Senha</label>
						<input type="text" value={dados.senha || ''} name="senha" onChange={controlarItem} maxLength="30" />
						<label className="margem-antes">Usuário 0800</label>
						<input type="text" value={dados.usuario0800 || ''} name="usuario0800" onChange={controlarItem} maxLength="30" />
						<label className="margem-antes">Senha 0800</label>
						<input type="text" value={dados.senha0800 || ''} name="senha0800" onChange={controlarItem} maxLength="30" />
						<label className="margem-antes">SRF</label>
						<select value={dados.srfCodigo} name="codigoSrf" onChange={controlarSrf} ref={txtSrf}>
							{dadosSrf.map((reg) => {
								return (
									<option key={"s" + reg.codigo} value={reg.codigo}>{reg.nome}</option>
								)
							})}
						</select>
						<label className="margem-antes">Observação</label>
						<textarea name="obs" value={dados.obs || ''} onChange={controlarItem} rows="5" />
						<label className="margem-antes"></label>
						<Button variant="contained" color="primary" onClick={ () => salvar()}>Salvar</Button>
					</form>
				</div>
			</div>
		</div >
	)

}